import { Box } from "@mui/material";
import { useMemo } from "react";
import { distinctBy } from "@entrilia/shared/utilities/arrayHelper";
import type { ParameterDictionary, WorkbookFilter } from "../../../../../api/types/workbookRuns.types";
import WorkbookFilterItem from "./workbook-filters/WorkbookFilterItem";

interface Props {
  filters: WorkbookFilter[];
  onUpdateDateFilter: (filterId: string, filterValue: string, isValid: boolean) => void;
  onUpdateTextFilter: (filterId: string, values: ParameterDictionary[]) => void;
}

const WorkbookFiltersSelector = ({ filters, onUpdateDateFilter, onUpdateTextFilter }: Props) => {
  const isMultiClientFilters = useMemo(() => {
    return (
      distinctBy(
        filters.filter((f) => f.type === "Table"),
        (f) => f.clientCode
      ).length > 1
    );
  }, [filters]);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "0.7fr 1fr",
        alignItems: "center",
        rowGap: 1,
        columnGap: 1,
        "& > *": {
          minHeight: "38px",
        },
        pt: 1,
      }}
    >
      {filters.map((filter) => {
        return (
          <WorkbookFilterItem
            key={filter.id}
            onUpdateDateFilterValue={(filterValue, isValid) => onUpdateDateFilter(filter.id, filterValue, isValid)}
            onUpdateTextFilterValue={(values) => onUpdateTextFilter(filter.id, values)}
            filter={filter}
            showCompanyLogo={isMultiClientFilters}
          />
        );
      })}
    </Box>
  );
};

export default WorkbookFiltersSelector;
